(function () {
  var modal = document.querySelector('[data-singles-slabs-disclaimer-modal]');
  if (!modal) return;

  var dialog = modal.querySelector('.singles-slabs-disclaimer__dialog');
  var agreeButton = modal.querySelector('[data-singles-slabs-disclaimer-agree]');
  var cancelButtons = modal.querySelectorAll('[data-singles-slabs-disclaimer-cancel]');
  var pendingForm = null;
  var pendingSubmitter = null;
  var previousActiveElement = null;

  function getFocusableElements() {
    return Array.prototype.slice
      .call(modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
      .filter(function (element) {
        return !element.disabled && element.offsetParent !== null;
      });
  }

  function openModal(form, submitter) {
    pendingForm = form;
    pendingSubmitter = submitter;
    previousActiveElement = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('singles-slabs-disclaimer-open');
    window.setTimeout(function () {
      if (dialog) dialog.focus();
    }, 0);
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('singles-slabs-disclaimer-open');
    pendingForm = null;
    pendingSubmitter = null;
    if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
      previousActiveElement.focus();
    }
    previousActiveElement = null;
  }

  function replaySubmit() {
    var form = pendingForm;
    var submitter = pendingSubmitter;
    closeModal();
    if (!form) return;

    form.dataset.singlesSlabsDisclaimerAccepted = 'true';

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(submitter instanceof HTMLElement ? submitter : undefined);
      return;
    }

    var event = new Event('submit', { bubbles: true, cancelable: true });
    if (form.dispatchEvent(event)) {
      form.submit();
    }
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.dataset.singlesSlabsDisclaimer !== 'true') return;

      if (form.dataset.singlesSlabsDisclaimerAccepted === 'true') {
        delete form.dataset.singlesSlabsDisclaimerAccepted;
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      openModal(form, event.submitter || document.activeElement);
    },
    true
  );

  if (agreeButton) {
    agreeButton.addEventListener('click', replaySubmit);
  }

  cancelButtons.forEach(function (button) {
    button.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (event) {
    if (modal.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key !== 'Tab') return;

    var focusable = getFocusableElements();
    if (focusable.length === 0) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
